import { getPercentage } from '@/libs/utils'

export function normalizeClickData (rawData, totalPv, device, captureWidth, captureHeight) {
  const targetTagSet = {
    'A': 1,
    'AREA': 1,
    'INPUT': 1,
    'BUTTON': 1,
    'SELECT': 1
  }

  const coords = {}
  const coordsIds = []
  const areaData = rawData.dom

  for (const [selector, item] of Object.entries(areaData)) {
    const tagName = item.r[6]
    const isTrackingTag = !!item.r[7]
    const isClickDom = !!item.r[8]

    if (targetTagSet[tagName] || isTrackingTag || isClickDom) {
      let left = item.r[3]
      let top = item.r[0]
      let width = item.r[4]
      let height = item.r[5]

      const isValidRect = (item.clickCnt > 0 || item.tabCnt > 0 || item.doubleTabCnt > 0 || item.zoominCnt > 0 || item.zoomoutCnt > 0) && width > 0 && height > 0 &&
        top >= 0 && left >= 0 &&
        (left + width) <= captureWidth &&
        (top + height) <= captureHeight

      if (isValidRect) {
        const coordData = {
          top,
          left,
          width,
          height,
          selector,
          isTrackingTag,
          showDetail: false,
          // for layer position calculation
          isSizeCalculated: false,
          pvCount: item.pv,
          clickCount: item.clickCnt,
          clickRate: item.clickRate || item.tabRate,
          clickPerPv: item.clickCnt / totalPv * 100,
          clickPvRate: getPercentage(item.pv, totalPv),
          hoverCount: item.hoverCnt,
          tapCount: item.tabCnt,
          tapRate: item.tabRate,
          tapPerPv: item.tabCnt / totalPv * 100,
          tapPvRate: getPercentage(item.pv, totalPv),
          doubleTapCount: item.doubletabCnt,
          doubleTapRate: item.doubletabRate,
          zoominCount: item.zoominCnt,
          zoominRate: item.zoominRate,
          zoomoutCount: item.zoomoutCnt,
          zoomoutRate: item.zoomoutRate
        }

        if (device === 'desktop') {
          coordData.hoverClickRate = getPercentage(item.clickCnt, item.hoverCnt)
          coordData.hoverClickTime = item.clickCnt ? item.time / item.clickCnt / 1000 : 0
        }

        if (item.scrollPvToPv) {
          // coordData.scrollPv = item.scrollPv
          coordData.scrollPvToPv = item.scrollPvToPv
        }

        coordsIds.push(selector)
        coords[selector] = coordData
      }
    }

    coordsIds.sort((a, b) => {
      const aArea = coords[a].width * coords[a].height
      const bArea = coords[b].width * coords[b].height
      return bArea - aArea
    })
  }

  return {
    coords,
    coordsIds,
    topClicks: rawData.topClicks,
    topHovers: rawData.topHovers,
    topZoomin: rawData.topZoomin,
    topZoomout: rawData.topZoomout,
    topPvs: rawData.topPvs,
    totalClick: rawData.metric ? (rawData.metric.clickCount || rawData.metric.tabCount) : null,
    totalHover: rawData.metric ? (rawData.metric.hoverCount || rawData.metric.zoominCount) : null,
    dailyDate: rawData.dailyClicks
  }
}

export function normalizeTextData (rawData, totalPv, device, captureWidth, captureHeight) {
  const coords = {}
  const coordsIds = []

  for (const [selector, item] of Object.entries(rawData)) {
    const isTrackingTag = true

    let left = item[3]
    let top = item[0]
    let width = item[4]
    let height = item[5]

    const coordData = {
      top,
      left,
      width,
      height,
      selector,
      isTrackingTag,
      showDetail: false,
      // for layer position calculation
      isSizeCalculated: false,
      pvCount: 0,
      clickCount: 0,
      clickRate: 0,
      clickPerPv: 0,
      clickPvRate: 0,
      hoverCount: 0,
      tapCount: 0,
      tapRate: 0,
      tapPerPv: 0,
      tapPvRate: 0,
      doubleTapCount: 0,
      doubleTapRate: 0,
      zoominCount: 0,
      zoominRate: 0,
      zoomoutCount: 0,
      zoomoutRate: 0
    }

    if (device === 'desktop') {
      coordData.hoverClickRate = getPercentage(item.clickCnt, item.hoverCnt)
      coordData.hoverClickTime = item.clickCnt ? item.time / item.clickCnt / 1000 : 0
    }

    if (item.scrollPvToPv) {
      // coordData.scrollPv = item.scrollPv
      coordData.scrollPvToPv = item.scrollPvToPv
    }

    coordsIds.push(selector)
    coords[selector] = coordData

    coordsIds.sort((a, b) => {
      const aArea = coords[a].width * coords[a].height
      const bArea = coords[b].width * coords[b].height
      return bArea - aArea
    })
  }

  return {
    coords,
    coordsIds,
    topClicks: rawData.topClicks,
    topHovers: rawData.topHovers,
    topZoomin: rawData.topZoomin,
    topZoomout: rawData.topZoomout,
    topPvs: rawData.topPvs,
    totalClick: rawData.metric ? (rawData.metric.clickCount || rawData.metric.tabCount) : null,
    totalHover: rawData.metric ? (rawData.metric.hoverCount || rawData.metric.zoominCount) : null
  }
}

export function normalizeSwipeData (rawData) {
  let swipeData = [
    {
      left: rawData.swipeUp,
      right: rawData.swipeDown
    },
    {
      left: rawData.swipeLeft,
      right: rawData.swipeRight
    }
  ]
  return swipeData
}

export function normalizeScrollData (rawData, captureHeight, params) {
  const scrollData = rawData.scroll
  const attentionData = rawData.attention
  const totalPv = rawData.count
  const scrollKeys = Object.keys(scrollData)
  const attentionMaxTime = rawData.max_attention

  if (!params.utid && totalPv < 3) {
    return null
  }

  if (!totalPv) {
    return null
  }

  function getScrollPointData () {
    let h80 = 1
    let h60 = 1
    let h40 = 1
    let h20 = 1
    const scrollArr = [0, 0, 0]

    for (const scrollKey of scrollKeys) {
      const height = Number(scrollKey)
      const value = scrollData[scrollKey]

      if (value >= 20 && h80 === 1) {
        h80 = height
      }
      if (value >= 25 && scrollArr[0] === 0) {
        scrollArr[0] = height
      }
      if (value >= 40 && h60 === 1) {
        h60 = height
      }
      if (value >= 50 && scrollArr[1] === 0) {
        scrollArr[1] = height
      }
      if (value >= 60 && h40 === 1) {
        h40 = height
      }
      if (value >= 75 && scrollArr[2] === 0) {
        scrollArr[2] = height
      }
      if (value >= 80 && h20 === 1) {
        h20 = height
      }
    }
    return {
      h20,
      h40,
      h60,
      h80,
      scrollArr
    }
  }

  function getScrollPvRateChartData () {
    const interval = 100
    const level = Math.ceil(captureHeight / interval)
    const pvData = {}
    let prevScrollPv = 0

    for (const scrollKey of scrollKeys) {
      const value = scrollData[scrollKey]
      const scrollPv = (value - prevScrollPv) / 100 * totalPv
      prevScrollPv = value

      const height = Math.round(Number(scrollKey) * captureHeight)
      const userMaxLevel = Math.ceil(height / interval)

      for (let i = 0; i < level; i++) {
        const scrollPx = (i + 1) * interval

        if (!pvData[scrollPx]) {
          pvData[scrollPx] = 0
        }

        if (i + 1 === userMaxLevel) {
          pvData[scrollPx] += scrollPv
        }
      }
    }

    let beforePv = 0
    let prevRealPv
    const chartData = []

    for (const scrollPx of Object.keys(pvData)) {
      const pv = pvData[scrollPx]
      beforePv += pv
      const realPv = totalPv - beforePv

      if (prevRealPv === undefined) {
        prevRealPv = realPv
      }

      const rate = getPercentage((prevRealPv + realPv) / 2, totalPv)
      prevRealPv = realPv

      chartData.push([
        Math.round(rate),
        scrollPx
      ])
    }
    return chartData
  }

  function getReachItems (scrollArr) {
    const r = 25
    const items = []

    for (let i = 0; i < 3; i++) {
      const scrollValue = scrollArr[i]
      const reach = scrollValue

      // check realRenderHeight
      if (reach && reach < 1) {
        items.push({
          reach,
          percentage: 100 - (r + (25 * i))
        })
      }
    }
    return items
  }

  function getAttentionItems () {
    const items = []

    for (let i = 0; i < attentionData.length; i++) {
      const dx = attentionData[i]
      const dy = i === 0 ? 0 : i + 1
      items.push({
        dx,
        dy,
        topPercentage: i + 1,
        percentage: (100 - scrollData[scrollKeys[i]]).toFixed(1),
        attention: Math.round(attentionData[i] * attentionMaxTime / 100) / 10
      })
    }
    return items
  }

  const data = {}
  const { h20, h40, h60, h80, scrollArr } = getScrollPointData()
  data.docHeight = rawData.docHeight
  data.fold = rawData.fold
  data.reachItems = getReachItems(scrollArr)
  data.h20 = h20
  data.h40 = h40
  data.h60 = h60
  data.h80 = h80

  data.attentionItems = getAttentionItems()
  data.scrollPvRateChartData = getScrollPvRateChartData()

  return data
}

export function normalizeStreamData (rawData, captureWidth, captureHeight) {
  if (!rawData || !rawData.path || !rawData.path.length) {
    return null
  }

  const pathCount = rawData.path.length

  rawData.path = rawData.path.filter(item => item.r && item.r.length).map((item, index) => {
    const left = item.r[3]
    const top = item.r[0]
    const width = item.r[4]
    const height = item.r[5]
    const x = left + (width / 2)
    const y = top + (height / 2)

    const coords = {
      left,
      top,
      width,
      height,
      x,
      y
    }
    const isOffScreen = x < 0 || y < 0 || x > captureWidth || y > captureHeight
    return {
      ...item,
      coords,
      isOffScreen
    }
  })

  // has filtered items
  if (rawData.path.length !== pathCount) {
    rawData.hasNoCoordsItem = true
  }
  return rawData
}

export function heatmapDataCheckByCapture (data, captureWidth, captureHeight) {
  const rawData = {
    ...data
  }

  for (const xKey of Object.keys(rawData)) {
    if (xKey > captureWidth) {
      delete rawData[xKey]
    } else {
      for (const yKey of Object.keys(rawData[xKey])) {
        if (yKey > captureHeight) {
          delete rawData[xKey][yKey]
        }
      }
    }
  }
  return rawData
}
